import { AspectRatio, Card, Image, Stack, Title, TitleOrder, useMatches } from '@mantine/core'
import { Link } from '@tanstack/react-router'
import LoadingImage from 'common/LoadingImage'
import NoImage from 'common/NoImage'
import { useEffect, useState } from 'react'
import { Product } from 'types/products'
import { getMiniImageUrl } from 'utils'
import styles from './ProductCard.module.scss'

type Props = {
  product: Product
}

export default function ProductCard({ product }: Props) {
  const [imageUrl, setImageUrl] = useState<string | undefined>()

  useEffect(() => {
    if (product.image) {
      getMiniImageUrl(product.image).then(setImageUrl)
    }
  }, [product.image])

  const symbolTextSize: TitleOrder = useMatches({
    base: 5,
    md: 4,
  })

  return (
    <Card
      className={styles.productCard}
      component={Link}
      to={`/product/${product.id}`}
      shadow="sm"
      padding="lg"
      pb="sm"
      radius="md"
      withBorder
    >
      {product.image ? (
        imageUrl ? (
          <Card.Section>
            <AspectRatio className={styles.imageWrapper}>
              <Image
                className={styles.image}
                src={imageUrl}
                alt={product.symbol}
                fallbackSrc="https://placehold.co/250x250/dee2e6/ffffff?text=Niepoprawny+link&font=roboto"
              />
            </AspectRatio>
          </Card.Section>
        ) : (
          <Card.Section>
            <LoadingImage withoutBorderRadius />
          </Card.Section>
        )
      ) : (
        <Card.Section>
          <NoImage withoutBorderRadius />
        </Card.Section>
      )}
      <Stack align="center" gap={0}>
        <Title mt="xs" order={symbolTextSize}>
          {product.symbol}
        </Title>
        <Title mt={0} c="dimmed" order={6}>
          {product.alternateSymbol}
        </Title>
      </Stack>
      {/* <Button fullWidth mt="auto" radius="md" size="sm">
        Zobacz produkt
      </Button> */}
    </Card>
  )
}
